/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wide_Tall_Hen_WalkInputs */

const en_wide_tall_hen_walk = /** @type {(inputs: Wide_Tall_Hen_WalkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rows per page`)
};

const de_wide_tall_hen_walk = /** @type {(inputs: Wide_Tall_Hen_WalkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeilen pro Seite`)
};

/**
* | output |
* | --- |
* | "Rows per page" |
*
* @param {Wide_Tall_Hen_WalkInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const wide_tall_hen_walk = /** @type {((inputs?: Wide_Tall_Hen_WalkInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wide_Tall_Hen_WalkInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_wide_tall_hen_walk(inputs)
	return de_wide_tall_hen_walk(inputs)
});